<div class="floating-print-btn no-print d-none d-md-block">
  <button class="btn btn-primary" (click)="printTicket()">
    <i class="fa fa-print"></i> Print Ticket
  </button>
</div>

<div class="floating-print-btn-2 no-print d-none d-md-block">
  <button class="btn btn-warning" (click)="back()">
    <i class="fa fa-angle-left"></i> Back
  </button>
</div>

<!-- MOBILE TICKET -->
<div class="mobile-ticket d-block d-md-none">
  <!-- HEADER -->
  <div class="ticket-header">
    <div class="logo-row">
      <img src="../../assets/img/email-logo.png" class="ticket-logo" />
      <div>
        <h2>ODBUS E-Ticket</h2>
        <p>Electronic Reservation Slip</p>
      </div>
    </div>
  </div>

  <!-- JOURNEY -->
  <div class="ticket-card">
    <div class="section-title">Journey Details</div>

    <div class="route-box">
      <div class="city-block">
        <label>From</label>
        <h4>{{ source }}</h4>
      </div>

      <div class="route-line">
        <span></span>
        <i class="fas fa-arrow-right"></i>
        <span></span>
      </div>

      <div class="city-block">
        <label>To</label>
        <h4>{{ destination }}</h4>
      </div>
    </div>

    <div class="ticket-grid">
      <div>
        <label>PNR</label>
        <strong>{{ pnr }}</strong>
      </div>

      <div>
        <label>Booking Date</label>
        <strong>{{ bookingDate | date: "dd MMM yyyy HH:mm:ss" }}</strong>
      </div>

      <div>
        <label>Boarding</label>
        <strong>
          {{ ticket?.booking?.boarding_point }}
        </strong>
      </div>

      <div>
        <label>Dropping</label>
        <strong>
          {{ ticket?.booking?.dropping_point }}
        </strong>
      </div>

      <div>
        <label>Journey Date</label>
        <strong>
          {{ entdate | date: "dd MMM yyyy" }}
        </strong>
      </div>

      <div>
        <label>Seat(s)</label>
        <strong>{{ total_seat_name }}</strong>
      </div>
    </div>
  </div>

  <!-- BUS -->
  <div class="ticket-card">
    <div class="section-title">Bus Details</div>

    <div class="ticket-grid">
      <div>
        <label>Bus Name</label>
        <strong>{{ busRecord?.name }}</strong>
      </div>

      <div>
        <label>Bus Number</label>
        <strong>{{ busRecord?.bus_number }}</strong>
      </div>

      <div>
        <label>Conductor</label>
        <strong>{{ ticket?.conductor?.phone }}</strong>
      </div>

      <div>
        <label>Agent</label>
        <strong>{{ USERRECORDS?.phone }}</strong>
      </div>
    </div>
  </div>

  <!-- PASSENGERS -->
  <div class="ticket-card">
    <div class="section-title">Passenger Details</div>

    <div class="passenger-item" *ngFor="let dt of passengerData.bookingInfo.bookingDetail">
      <div class="passenger-left">
        <i class="fas fa-user-circle"></i>
        <span>{{ dt.passenger_name }}</span>
      </div>

      <div class="passenger-right">
        <span>{{ dt.passenger_age }}</span>
        <span>{{ dt.passenger_gender }}</span>
      </div>
    </div>
  </div>

  <!-- QR -->
  <div class="ticket-card">
    <div class="section-title">Scan Ticket</div>

    <div class="qr-wrapper">
      <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="qrcode" [width]="220">
      </ngx-qrcode>
    </div>
  </div>

  <!-- FARE -->
  <div class="ticket-card">
    <div class="section-title">Fare Details</div>

    <div class="fare-box">
      <div class="fare-row">
        <span>Base Fare</span>
        <strong>
          ₹{{ bookingdata?.PriceArray?.odbus_charges_ownerFare }}
        </strong>
      </div>

      <div class="fare-row">
        <span>GST</span>
        <strong> + ₹{{ bookingdata?.PriceArray?.customerGst }} </strong>
      </div>

      <div class="fare-row" *ngIf="applied_comission > 0">
        <span>Commission</span>
        <strong> + ₹{{ applied_comission }} </strong>
      </div>

      <div class="fare-row total">
        <span>Total Fare</span>
        <strong> ₹{{ payableAmount }} </strong>
      </div>
    </div>
  </div>

  <!-- TERMS & CONDITIONS -->
  <div class="ticket-card mobile-terms-card">

    <div class="terms-header" (click)="showTerms = !showTerms">

      <div class="section-title mb-0">
        Terms & Conditions
      </div>

      <button class="terms-toggle-btn">
        {{ showTerms ? 'Hide' : 'Show' }}
      </button>

    </div>

    <div class="terms-content" *ngIf="showTerms">

      <div class="terms-section">

        <h5>ARE NOT ODBUS RESPONSIBILITIES</h5>

        <ol>
          <li>Any incorrect data provided by customer while booking the ticket.</li>
          <li>Any Bus delays, breakdowns, service cancellations and accidents.</li>
          <li>Any misbehavior by the bus partner staff or co-passenger.</li>
          <li>Loss/damage of baggage.</li>
          <li>Late arrival by customer at the boarding point.</li>
          <li>Customer phone not reachable and bus left without picking the customer.</li>
          <li>Customer waiting at wrong boarding point.</li>
          <li>Any change of seat numbers done by the bus conductor manually.</li>
          <li>Bus partner changing the boarding point for any reason.</li>
          <li>Bus conductor arranging a different vehicle for pickup.</li>
          <li>Bus conductor objecting on carrying pets.</li>
          <li>Improper booking done by agent.</li>
          <li>Bus owners not providing facilities mentioned while booking.</li>
          <li>Change of bus type by bus owner for any reason.</li>
          <li>Bus fares are not controlled by ODBUS.</li>
          <li>Fare may vary based on seat selection.</li>
        </ol>

      </div>

      <div class="terms-section">

        <h5>CANCELLATION POLICY</h5>

        <p>
          The tickets booked through ODBUS can be cancelled before
          12 hours of departure of the said bus.
        </p>

        <ol>
          <li>Partial cancellation is not allowed in ODBUS.</li>
          <li>For refund issues mail support@odbus.in mentioning PNR.</li>
          <li>Refunds are normally processed within 10-12 working days.</li>
          <li>Customer can't claim cancellation refund on rescheduled tickets.</li>
          <li>Cancellation terms vary according to operator policy.</li>
          <li>Tickets booked online should be cancelled online only.</li>
          <li>Transaction Fee / GST are non-refundable.</li>
          <li>Cancellation charges apply on Base Fare only.</li>
        </ol>

      </div>

    </div>

  </div>
</div>

<div class="desktop-ticket">
  <div class="container" id="print-section">
    <div class="od-body mb25">
      <div class="row mb40">
        <table class="tableclass2" cellpadding="10">
          <tbody>
            <tr>
              <td>
                <img src="../../assets/img/email-logo.png" class="od-logo" />
              </td>
              <td>
                <span>ODBUS</span> e-Ticketing Service<br />
                Electronic Reservation Slip
              </td>
              <td>
                <div class="od-bktext">Booking Date</div>
                <div class="od-bktext">
                  {{ bookingDate | date: "EEEE, d MMMM y HH:mm" }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- JOURNEY DETAILS -->
      <div class="row mt30 mb25">
        <div class="col-md-12 odtext24">
          <h3>JOURNEY DETAILS:</h3>

          <table width="100%">
            <tr>
              <td>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>PNR No: {{ pnr }}</th>
                      <th>
                        Bus Name/Number:
                        {{ busRecord?.name }} - {{ busRecord?.bus_number }}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        Journey Date:
                        {{ entdate | date: "EEEE, d MMMM y" }}
                      </td>
                      <td>Bus Route: {{ source }} - {{ destination }}</td>
                    </tr>

                    <tr>
                      <td>
                        Departure Timing:
                        {{ ticket?.booking?.boarding_time }}
                      </td>

                      <td>
                        Arrival Timing:
                        {{ ticket?.booking?.dropping_time }}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        From:
                        {{ source }}
                      </td>

                      <td>
                        To:
                        {{ destination }}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Passenger Mobile No: +91
                        {{ passengerData?.customerInfo.phone }}
                      </td>

                      <td>
                        Conductor Mobile No:
                        {{ ticket?.conductor?.phone }}
                      </td>
                    </tr>

                    <tr>
                      <td>Agent Mobile No: +91 {{ USERRECORDS?.phone }}</td>

                      <td>
                        Seat(s):
                        {{ total_seat_name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td width="220">
                <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="qrcode"
                  [width]="180">
                </ngx-qrcode>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- PASSENGER DETAILS -->
      <div class="row mt30 mb25">
        <div class="col-md-12 odtext24">
          <h3>PASSENGER DETAILS:</h3>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Sl.</th>
                <th>Name</th>
                <th>Age</th>
                <th>Sex</th>
                <th>Seat</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="
                  let dt of passengerData.bookingInfo.bookingDetail;
                  let i = index
                ">
                <td>{{ i + 1 }}</td>
                <td>{{ dt.passenger_name }}</td>
                <td>{{ dt.passenger_age }}</td>
                <td>{{ dt.passenger_gender }}</td>
                <td>{{ dt.seat_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- FARE BREAKUP -->

      <hr />
    </div>
    <!-- CANCELLATION POLICY + TERMS -->
    <div class="row mt30">
      <div class="col-md-6">
        <h3>FARE BREAKUP</h3>

        <table class="table table-bordered">
          <tr>
            <td>Base Fare</td>
            <td>₹{{ bookingdata?.PriceArray.odbus_charges_ownerFare }}</td>
          </tr>

          <tr>
            <td>Customer GST</td>
            <td>+₹{{ bookingdata?.PriceArray.customerGst }}</td>
          </tr>

          <tr *ngIf="applied_comission > 0">
            <td>Commission</td>
            <td>+₹{{ applied_comission }}</td>
          </tr>

          <tr>
            <td><strong>Total Fare</strong></td>
            <td>
              <strong>₹{{ payableAmount }}</strong>
            </td>
          </tr>
        </table>
      </div>

      <div class="col-md-6">
        <h3>CANCELLATION POLICY</h3>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Cancellation Time</th>
              <th>Cancellation Charges</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>12-18 hr</td>
              <td>35%</td>
            </tr>

            <tr>
              <td>18-24 hr</td>
              <td>25%</td>
            </tr>

            <tr>
              <td>24-999 hr</td>
              <td>20%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row mt30">
      <div class="col-md-12">
        <h3>TERMS & CONDITIONS</h3>

        <div class="border p-3">
          <div class="row">
            <div class="col-md-6">
              <h5>ARE NOT ODBUS RESPONSIBILITIES</h5>

              <ol>
                <li>
                  Any incorrect data provided by customer while booking the
                  ticket.
                </li>
                <li>
                  Any Bus delays, breakdowns, service cancellations and
                  accidents.
                </li>
                <li>
                  Any misbehavior by the bus partner staff or co-passenger.
                </li>
                <li>Loss/damage of baggage.</li>
                <li>Late arrival by customer at the boarding point.</li>
                <li>
                  Customer phone not reachable and bus left without picking the
                  customer.
                </li>
                <li>Customer waiting at wrong boarding point.</li>
                <li>
                  Any change of seat numbers done by the bus conductor manually.
                </li>
                <li>Bus partner changing the boarding point for any reason.</li>
                <li>Bus conductor arranging a different vehicle for pickup.</li>
                <li>Bus conductor objecting on carrying pets.</li>
                <li>
                  Improper booking done by agent, please contact the agent
                  directly.
                </li>
                <li>
                  Bus owners not providing facilities mentioned while booking.
                </li>
                <li>Change of bus type by bus owner for any reason.</li>
                <li>Bus fares are not controlled by ODBUS.</li>
                <li>Fare may vary based on seat selection.</li>
              </ol>
            </div>

            <div class="col-md-6">
              <h5>CANCELLATION POLICY</h5>

              <p>
                The tickets booked through ODBUS can be cancelled before 12
                hours of departure of the said bus.
              </p>

              <ol>
                <li>Partial cancellation is not allowed in ODBUS.</li>
                <li>For refund issues mail support@odbus.in mentioning PNR.</li>
                <li>
                  Refunds are normally processed within 10-12 working days.
                </li>
                <li>
                  Customer can't claim cancellation refund on rescheduled
                  tickets.
                </li>
                <li>Cancellation terms vary according to operator policy.</li>
                <li>Tickets booked online should be cancelled online only.</li>
                <li>Transaction Fee / GST are non-refundable.</li>
                <li>Cancellation charges apply on Base Fare only.</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt30">
      <div class="col-md-12">
        <div class="border p-4">
          <h3>Contact Information</h3>

          <br />

          <h4>ODBUS Helpline (07:00 AM To 11:00 PM): 9583-918-888</h4>

          <p>(For Online Booking issue or Online Cancellation issue.)</p>

          <br />

          <h4>ODBUS Customer Support Email: support@odbus.in</h4>

          <p>(Response time 3 working days)</p>

          <br /><br />

          <div class="text-right">
            <h3>Thankyou</h3>
            <h3>Team ODBUS</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>